import script from "./personalInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./personalInfo.vue?vue&type=script&setup=true&lang=js"

import "./personalInfo.vue?vue&type=style&index=0&id=70e5bc62&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\baoda\\salary\\wages-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70e5bc62"]])

export default __exports__